import { AbacusClient } from "#lib/api/abacus.js";
import { staticClientOptions, type ClientOptions } from "#lib/api/api.js";
import { AudiencesClient } from "#lib/api/audiences.js";
import { AuditClient } from "#lib/api/audit.js";
import { BillingClient } from "#lib/api/billing.js";
import { BrandClient } from "#lib/api/brands.js";
import { BundleClient } from "#lib/api/bundles.js";
import { CodesClient } from "#lib/api/codes.js";
import { ComplianceClient } from "#lib/api/compliance.js";
import { ConversionsDevelopersClient } from "#lib/api/conversions-developers.js";
import { EntrypointsClient } from "#lib/api/entrypoints.js";
import { EventClient } from "#lib/api/events.js";
import { FolderClient } from "#lib/api/folder.js";
import { IdentitiesClient } from "#lib/api/identities.js";
import { IntegrationsClient } from "#lib/api/integrations.js";
import { LegalClient } from "#lib/api/legal.js";
import { LinksClient } from "#lib/api/links.js";
import { NotificationTemplateClient } from "#lib/api/notification-templates.js";
import { NotificationClient } from "#lib/api/notifications.js";
import { OnboardingClient } from "#lib/api/onboarding.js";
import { PageClient } from "#lib/api/pages.js";
import { PixelTrackerClient } from "#lib/api/pixel-tracker.js";
import { PollsClient } from "#lib/api/polls.js";
import { ProductClient } from "#lib/api/products.js";
import { RegistryClient } from "#lib/api/registry.js";
import { ReportsClient } from "#lib/api/reports.js";
import { ScanabilityClient } from "#lib/api/scanability.js";
import { SearchClient } from "#lib/api/search.js";
import { ShortUrlsClient } from "#lib/api/shortUrls.js";
import { StaticAssetClient } from "#lib/api/static-assets.js";
import { StatusClient } from "#lib/api/status.js";
import { TagClient } from "#lib/api/tags.js";
import { WebhooksClient } from "#lib/api/webhooks.js";

export function newApiClients(options: ClientOptions) {
	const clientOptionsBase = staticClientOptions(options);
	const clientOptionsWithCookies = staticClientOptions(options, true);

	return {
		audiencesClient: new AudiencesClient(clientOptionsBase),
		auditClient: new AuditClient(clientOptionsBase),
		billingClient: new BillingClient(clientOptionsBase),
		bundleClient: new BundleClient(clientOptionsWithCookies),
		pageClient: new PageClient(clientOptionsBase),
		registryClient: new RegistryClient(clientOptionsBase),
		staticAssetClient: new StaticAssetClient(clientOptionsBase),
		brandClient: new BrandClient(clientOptionsBase),
		folderClient: new FolderClient(clientOptionsBase),
		tagClient: new TagClient(clientOptionsBase),
		productClient: new ProductClient(clientOptionsWithCookies),
		codesClient: new CodesClient(clientOptionsBase),
		entrypointsClient: new EntrypointsClient(clientOptionsBase),
		statusClient: new StatusClient(clientOptionsBase),
		shortUrlsClient: new ShortUrlsClient(clientOptionsBase),
		searchClient: new SearchClient(clientOptionsBase),
		linksClient: new LinksClient(clientOptionsBase),
		identitiesClient: new IdentitiesClient(clientOptionsBase),
		pixelTrackerClient: new PixelTrackerClient(clientOptionsBase),
		webhooksClient: new WebhooksClient(clientOptionsBase),
		integrationsClient: new IntegrationsClient(clientOptionsBase),
		abacusClient: new AbacusClient(clientOptionsBase),
		notificationTemplateClient: new NotificationTemplateClient(clientOptionsBase),
		notificationClient: new NotificationClient(clientOptionsBase),
		conversionsDevelopersClient: new ConversionsDevelopersClient(clientOptionsBase),
		scanabilityClient: new ScanabilityClient(clientOptionsBase),
		reportsClient: new ReportsClient(clientOptionsBase),
		legalClient: new LegalClient(clientOptionsBase),
		onboardingClient: new OnboardingClient(clientOptionsBase),
		eventClient: new EventClient(clientOptionsBase),
		complianceClient: new ComplianceClient(clientOptionsBase),
		pollsClient: new PollsClient(clientOptionsBase),
	};
}
